// API configuration
// In development, requests to /api/* are proxied to http://localhost:5000 via the proxy setting in package.json
// In production, the React app should be served from the same origin as the API server
// If you need to override the API URL at runtime (e.g., for different environments),
// you can set window.REACT_APP_API_URL in public/index.html or via server-side injection

const getApiUrl = () => {
  // Check for runtime configuration (allows dynamic configuration without rebuilding)
  if (window.REACT_APP_API_URL) {
    return window.REACT_APP_API_URL;
  }

  // Use relative path - works with proxy in development and same-origin deployment in production
  return '/api/v1';
};

const API_URL = getApiUrl();

export { getApiUrl };
export default API_URL;